"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sant-apollinare": {
    "687cec43": [{
      "hkey": "cfc49cef",
      "slug": "giunture",
      "name": "Giunture",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-giunture": [{
      "hkey": "cfc49cef",
      "slug": "giunture",
      "name": "Giunture",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a5f6feb4": [{
      "hkey": "27d0398d",
      "slug": "sant-apollinare",
      "name": "Sant'Apollinare",
      "primary": true,
      "skipSearch": false
    }],
    "pagliare": [{
      "hkey": "27d0398d",
      "slug": "sant-apollinare",
      "name": "Sant'Apollinare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;